const DEFAULT_AUTO_LOOP_INTERVAL = 5000;
export class UISetting {
    constructor(source) {
        this.useArrows = !!source.useArrows;
        this.Draggable = !!source.Draggable;
        this.Pagination = !!source.Pagination;
        this.autoLoop = {
            enabled: !!source.AutoLooping,
            duration: parseInt(source.TimeLooping) || DEFAULT_AUTO_LOOP_INTERVAL
        };
    }
}
//# sourceMappingURL=UISetting.js.map